import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/bookeditor/bookeditor/prototypes/ui.v1/src/app/RootLayoutClient.tsx");
